export default "__VITE_ASSET__8f3f6137__"